import {NodeDef} from "../../parser/definition/types/NodeDef";
import {StructureNodeDef} from "../../parser/definition/types/StructureNodeDef";

export function isStructureNodeDef<I, O>(
  nodeDef: NodeDef<I, O>
): boolean {
  const structureNodeDef = nodeDef as StructureNodeDef<I, O, any>;
  return !!structureNodeDef.childNodesProps
    || structureNodeDef.connections
    || structureNodeDef.exposedInputs
    || structureNodeDef.exposedOutputs;
}
